var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSeeMoreArrow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.13652 9.30949C1.2139 9.32188 1.2922 9.3276 1.37054 9.3266H14.7105L14.4197 9.46009C14.1353 9.59286 13.8767 9.77357 13.6552 9.99403L9.91438 13.6849C9.42169 14.149 9.33891 14.8955 9.7182 15.4536C10.1596 16.0485 11.0062 16.1776 11.6091 15.7421C11.6578 15.7069 11.7041 15.6685 11.7476 15.6272L18.5123 8.95283C19.0409 8.43182 19.0414 7.58664 18.5133 7.06504L18.5123 7.064L11.7476 0.389651C11.2185 -0.130905 10.3619 -0.129738 9.83426 0.392279C9.79274 0.433368 9.75397 0.477084 9.7182 0.523137C9.33891 1.08132 9.42169 1.82781 9.91438 2.29184L13.6485 5.98943C13.847 6.18548 14.0752 6.34988 14.3249 6.47665L14.7308 6.65686H1.44499C0.753855 6.63154 0.147486 7.10788 0.0176468 7.77815C-0.101961 8.50586 0.398962 9.19144 1.13652 9.30949Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSeeMoreArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/see-more-arrow.7574a26ad5827173c15b4a932713bdb2.svg";